import React from 'react'
import PropTypes from 'prop-types'

export const ProgressBar = props => {
  if (props.isDone) {
    return (
      <div className="progress-container-container mt-0">
        <div className="finished-container">
          <div className="finished-circle">
            <i className="fas fa-check-circle fa-2x circle" />
            <div className="strong">Exception Created</div>
          </div>
        </div>
      </div>
    )
  }
  return (
    <div className="progress-container-container">
      <div className="progress-container">
        <div className="circle">
          <i
            className={
              props.createException
                ? 'circle-current fas fa-circle fa-lg'
                : 'fas fa-check-circle fa-lg circle-current'
            }
          />
          <div className={props.createException ? 'label-current' : ''}>
            Create Exception
          </div>
        </div>
        <div
          className={
            props.createException
              ? 'progress progress-1 inactive'
              : 'progress progress-1'
          }
        />
        <div className="circle">
          <i
            className={
              props.selectAssignments
                ? 'circle-current fas fa-circle fa-lg'
                : props.review
                ? 'fas fa-check-circle fa-lg circle-current'
                : 'fas fa-circle fa-lg inactive'
            }
          />
          <div
            className={
              props.selectAssignments
                ? 'label-current'
                : props.createException
                ? 'inactive'
                : 'undefined'
            }
          >
            Select Assignments
          </div>
        </div>
        <div
          className={
            !props.review
              ? 'progress progress-2 inactive'
              : 'progress progress-2'
          }
        />
        <div className="circle">
          <i
            className={
              props.reviewProgressBarCheck
                ? 'fas fa-check-circle fa-lg circle-current'
                : props.review
                ? 'circle-current fas fa-circle fa-lg'
                : 'fas fa-circle fa-lg inactive'
            }
          />
          <div className={props.review ? 'label-current' : 'inactive'}>
            Review
          </div>
        </div>
      </div>
    </div>
  )
}

ProgressBar.propTypes = {
  createException: PropTypes.bool.isRequired,
  selectAssignments: PropTypes.bool.isRequired,
  review: PropTypes.bool.isRequired,
  isDone: PropTypes.bool,
  reviewProgressBarCheck: PropTypes.bool,
}
